import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { session } = useAuth();

  // Se não houver sessão ativa, redireciona para a página de login
  if (!session) {
    return <Navigate to="/login" />;
  }

  // Se houver sessão, renderiza o componente filho (a página protegida)
  return children;
};

export default ProtectedRoute;